module.exports = __webpack_public_path__ + "static/media/halo-auto-background.a215fb78.svg";